import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "image", "caption", "prevButton", "nextButton"];

  static values = {
    currentIndex: Number,
    images: Array,
  };

  connect() {
    this.currentIndexValue = 0;
    this.imagesValue = [];

    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  open(event) {
    event.preventDefault();

    const trigger = event.currentTarget;

    if (trigger.dataset.lightboxImages) {
      try {
        const images = JSON.parse(trigger.dataset.lightboxImages);
        const captions = trigger.dataset.lightboxCaptions
          ? JSON.parse(trigger.dataset.lightboxCaptions)
          : [];

        this.imagesValue = images.map((src, index) => ({
          src,
          caption: captions[index] || "",
        }));

        this.currentIndexValue =
          parseInt(trigger.dataset.lightboxIndex, 10) || 0;
      } catch (e) {
        this.setSingleImage(trigger);
      }
    } else {
      this.collectImages(trigger);

      const imageSrc = trigger.dataset.lightboxImage || trigger.src;
      this.currentIndexValue = this.imagesValue.findIndex(
        (img) => img.src === imageSrc
      );
      if (this.currentIndexValue === -1) {
        this.currentIndexValue = 0;
      }
    }

    this.showImage();
    this.modalTarget.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  }

  close(event) {
    if (event) {
      event.preventDefault();
    }

    this.modalTarget.classList.add("hidden");
    document.body.style.overflow = "";
  }

  prev(event) {
    event.preventDefault();

    if (this.imagesValue.length > 1) {
      this.currentIndexValue =
        this.currentIndexValue > 0
          ? this.currentIndexValue - 1
          : this.imagesValue.length - 1;
      this.showImage();
    }
  }

  next(event) {
    event.preventDefault();

    if (this.imagesValue.length > 1) {
      this.currentIndexValue =
        this.currentIndexValue < this.imagesValue.length - 1
          ? this.currentIndexValue + 1
          : 0;
      this.showImage();
    }
  }

  handleKeydown(event) {
    if (!this.modalTarget.classList.contains("hidden")) {
      switch (event.key) {
        case "Escape":
          this.close();
          break;
        case "ArrowLeft":
          this.prev(event);
          break;
        case "ArrowRight":
          this.next(event);
          break;
        default:
          break;
      }
    }
  }

  backdropClose(event) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  collectImages(trigger) {
    const container =
      trigger.closest(".accommodation-container, .ProductGroupProfile-group") ||
      document;
    const lightboxImages = container.querySelectorAll(
      '[data-action*="lightbox#open"]'
    );

    this.imagesValue = Array.from(lightboxImages).map((img) => ({
      src: img.dataset.lightboxImage || img.src,
      caption: img.dataset.lightboxCaption || img.alt || "",
    }));
  }

  setSingleImage(trigger) {
    const imageSrc = trigger.dataset.lightboxImage || trigger.src;
    const imageAlt = trigger.dataset.lightboxCaption || trigger.alt || "";

    this.imagesValue = [
      {
        src: imageSrc,
        caption: imageAlt,
      },
    ];
    this.currentIndexValue = 0;
  }

  showImage() {
    const currentImage = this.imagesValue[this.currentIndexValue];

    if (currentImage) {
      this.imageTarget.src = currentImage.src;
      this.imageTarget.alt = currentImage.caption;

      if (this.hasCaptionTarget) {
        this.captionTarget.textContent = currentImage.caption;
      }
    }

    if (this.hasPrevButtonTarget && this.hasNextButtonTarget) {
      const hasMultiple = this.imagesValue.length > 1;
      this.prevButtonTarget.style.display = hasMultiple ? "block" : "none";
      this.nextButtonTarget.style.display = hasMultiple ? "block" : "none";
    }
  }
}
